"use strict";

exports.clientsAllowedToView = function (doc) {
  if (!doc.clients) {
    return [];
  }
  return doc.clients.filter(function (client) {
    return client.permissions.view;
  });
};

exports.primaryEventContact = function (doc) {
  if (!doc.clients) {
    return;
  }
  return doc.clients.find(function (client) {
    return client.isPrimary;
  });
};

exports.allowedToView = function (_ref) {
  var doc = _ref.doc,
      user = _ref.user;

  var userId = user._id ? user._id.toString() : user.toString();
  var client = findClient({ clients: doc.clients, userId: userId });
  return client && client.permissions.view;
};

function findClient(_ref2) {
  var clients = _ref2.clients,
      userId = _ref2.userId;

  return clients.find(function (client) {
    return client.user._id ? client.user._id.toString() === userId : client.user.toString() === userId;
  });
}